// client/src/components/ShipmentForm.js
import React, { useState, forwardRef, useImperativeHandle } from "react";

const ShipmentForm = forwardRef(
  ({ onSubmit, loading, onEnvelopeChange }, ref) => {
    const inputStyle = {
      width: "100%",
      height: "30px",
      marginTop: 4,
      borderRadius: 10,
      border: "1px solid #ccc",
      padding: "4px 8px",
      boxSizing: "border-box",
    };

    // RETURN (FROM) ADDRESS state
    const [fromName, setFromName] = useState("");
    const [fromEmail, setFromEmail] = useState("");
    const [fromStreet1, setFromStreet1] = useState("");
    const [fromCity, setFromCity] = useState("");
    const [fromState, setFromState] = useState("");
    const [fromZip, setFromZip] = useState("");
    const [fromCountry, setFromCountry] = useState("US"); // default to US
    const [fromPhone, setFromPhone] = useState("");
    const [orderNumber, setOrderNumber] = useState("");
    // const [isEnvelope, setIsEnvelope] = useState(false);
    // PARCEL state (single parcel for simplicity)
    // const [length, setLength] = useState("");
    // const [width, setWidth] = useState("");
    // const [height, setHeight] = useState("");
    // const [distanceUnit, setDistanceUnit] = useState("in");
    // const [weight, setWeight] = useState("");
    // const [massUnit, setMassUnit] = useState("lb");

    // TO address is fixed to 130 S 17th St, Philadelphia, PA 19103
    const toAddress = {
      name: "Photolounge", // can be a placeholder or real name
      street1: "130 S 17th St",
      city: "Philadelphia",
      state: "PA",
      zip: "19103",
      country: "US",
      phone: "" /* leave blank or prefill if you want */,
      email: "" /* optional */,
    };
    useImperativeHandle(ref, () => ({
      triggerSubmit: () => {
        const fromAddress = {
          name: fromName,
          email: fromEmail,
          street1: fromStreet1,
          city: fromCity,
          state: fromState,
          zip: fromZip,
          country: fromCountry,
          phone: fromPhone,
          metadata: `Order #${orderNumber}`,
        };

        const parcels = [
          {
            length: "12.5",
            width: "9.5",
            height: "0.75",
            distanceUnit: "in",
            weight: "0.5",
            massUnit: "lb",
          },
        ];

        onSubmit({
          fromAddress,
          toAddress,
          parcels,
        });
      },
    }));

    // const handleEnvelopeChange = (e) => {
    //   const checked = e.target.checked;
    //   setIsEnvelope(checked);
    //   if (onEnvelopeChange) {
    //     onEnvelopeChange(checked); // <-- Notify parent
    //   }
    // };

    return (
      <form style={{ marginBottom: 24 }}>
        <h2>Return Address (From)</h2>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <label>
            Name<span style={{ color: "red" }}>*</span>:
            <input
              type="text"
              value={fromName}
              onChange={(e) => setFromName(e.target.value)}
              required
              style={inputStyle}
            />
          </label>
          <label>
            Email<span style={{ color: "red" }}>*</span>:
            <input
              type="text"
              value={fromEmail}
              onChange={(e) => setFromEmail(e.target.value)}
              required
              style={inputStyle}
            />
          </label>

          <label>
            Street Address<span style={{ color: "red" }}>*</span>:
            <input
              type="text"
              value={fromStreet1}
              onChange={(e) => setFromStreet1(e.target.value)}
              required
              style={inputStyle}
            />
          </label>

          <div style={{ display: "flex", gap: 12 }}>
            <label style={{ flex: 2 }}>
              City<span style={{ color: "red" }}>*</span>:
              <input
                type="text"
                value={fromCity}
                onChange={(e) => setFromCity(e.target.value)}
                required
                style={inputStyle}
              />
            </label>
            <label style={{ flex: 1 }}>
              State<span style={{ color: "red" }}>*</span>:
              <input
                type="text"
                value={fromState}
                onChange={(e) => setFromState(e.target.value)}
                required
                maxLength={2}
                style={inputStyle}
              />
            </label>
            <label style={{ flex: 1 }}>
              ZIP<span style={{ color: "red" }}>*</span>:
              <input
                type="text"
                value={fromZip}
                onChange={(e) => setFromZip(e.target.value)}
                required
                style={inputStyle}
              />
            </label>
          </div>
          <label>
            Country<span style={{ color: "red" }}>*</span>:
            <input
              type="text"
              value={fromCountry}
              onChange={(e) => setFromCountry(e.target.value)}
              required
              maxLength={2}
              style={inputStyle}
            />
          </label>
          <label>
            Phone Number:
            <input
              type="tel"
              value={fromPhone}
              onChange={(e) => setFromPhone(e.target.value)}
              style={inputStyle}
            />
          </label>
          <label>
            Order #:
            <input
              type="text"
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
              style={inputStyle}
            />
          </label>
        </div>

        {/* <h2 style={{ marginTop: 24 }}>Choose Parcel</h2>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <label>
          <input
            type="checkbox"
            checked={isEnvelope}
            onChange={handleEnvelopeChange}
          />
          Use Flat-Rate Envelope (USPS)
        </label>
        <h2 style={{ marginTop: 20 }}>Custom (Using Your Own Packaging)</h2>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            marginBottom: -15,
          }}
        ></div>
        {!isEnvelope ? (
          <>
            <div style={{ display: "flex", gap: 12 }}>
              <label style={{ flex: 1 }}>
                Length<span style={{ color: "red" }}>*</span>:
                <input
                  type="number"
                  value={length}
                  onChange={(e) => setLength(e.target.value)}
                  required
                  style={inputStyle}
                />
              </label>
              <label style={{ flex: 1 }}>
                Width<span style={{ color: "red" }}>*</span>:
                <input
                  type="number"
                  value={width}
                  onChange={(e) => setWidth(e.target.value)}
                  required
                  style={inputStyle}
                />
              </label>
              <label style={{ flex: 1 }}>
                Height<span style={{ color: "red" }}>*</span>:
                <input
                  type="number"
                  value={height}
                  onChange={(e) => setHeight(e.target.value)}
                  required
                  style={inputStyle}
                />
              </label>
            </div>
            <div style={{ display: "flex", gap: 12 }}>
              <label style={{ flex: 1 }}>
                Distance Unit<span style={{ color: "red" }}>*</span>:
                <select
                  value={distanceUnit}
                  onChange={(e) => setDistanceUnit(e.target.value)}
                  required
                  style={inputStyle}
                >
                  <option value="in">inches</option>
                  <option value="cm">centimeters</option>
                </select>
              </label>
              <label style={{ flex: 1 }}>
                Weight<span style={{ color: "red" }}>*</span>:
                <input
                  type="number"
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}
                  required
                  style={inputStyle}
                />
              </label>
              <label style={{ flex: 1 }}>
                Mass Unit<span style={{ color: "red" }}>*</span>:
                <select
                  value={massUnit}
                  onChange={(e) => setMassUnit(e.target.value)}
                  required
                  style={inputStyle}
                >
                  <option value="lb">pounds</option>
                  <option value="kg">kilograms</option>
                </select>
              </label>
            </div>
          </>
        ) : (
          <p>(Using USPS Flat-Rate Envelope – no dimensions needed.)</p>
        )}
      </div> */}

        {/* <button
        type="submit"
        disabled={loading}
        style={{
          marginTop: 24,
          padding: "10px 20px",
          backgroundColor: "#ED174F",
          color: "white",
          border: "none",
          borderRadius: 10,
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        {loading ? "Loading label…" : "Prepare Label"}
      </button> */}
      </form>
    );
  },
);
export default ShipmentForm;
